import { ConfiguracionFicha } from 'src/app/compartido/ficha/utilidades/ficha.models';
import { Icono } from 'src/app/compartido/utilidades/compartido.static';

/* Configuración de la ficha de ver orden */
export const CONFIGURACION_FICHA_VER_ORDEN: ConfiguracionFicha = {
  header: { titulo: 'Orden', icono: Icono.ORDENES },
  maxWidth: 800,
};
